// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__92Wis","checked":"Checkbox_checked__K9z+8"};